<script>
export default {
  name: "SvgLoop",
};
</script>

<template>
  <svg
    id="loupe"
    xmlns="http://www.w3.org/2000/svg"
    width="23.5"
    height="23.499"
    viewBox="0 0 23.5 23.499"
  >
    <path
      id="Tracé_20"
      data-name="Tracé 20"
      d="M23.267,23.266a1.469,1.469,0,0,1,2.078,0L31,28.92A1.469,1.469,0,0,1,28.923,31l-5.654-5.654a1.469,1.469,0,0,1,0-2.078Z"
      transform="translate(-7.93 -7.929)"
      fill-rule="evenodd"
    />
    <path
      id="Tracé_21"
      data-name="Tracé 21"
      d="M9.547,17.625A8.078,8.078,0,1,0,1.469,9.547,8.078,8.078,0,0,0,9.547,17.625Zm9.547-8.078A9.547,9.547,0,1,1,9.547,0a9.547,9.547,0,0,1,9.547,9.547Z"
      transform="translate(0 0)"
      fill-rule="evenodd"
    />
  </svg>
</template>

<style></style>
